import { useMemo } from 'react';

import {
  type DataWarehouseRefFragment,
  type GraphQLAppError,
  getError,
  getTypeOrNull,
  useDataWarehousesQuery,
} from '@spotify/confidence-graphql';

import { findPrimaryWarehouse } from '../../helpers/findPrimaryWarehouse';

export type UseDataWarehousesResult = {
  warehouses: DataWarehouseRefFragment[];
  primaryWarehouse: DataWarehouseRefFragment | undefined;
  isLoading: boolean;
  error: GraphQLAppError | null;
};

export const useDataWarehouses = (options?: {
  skip?: boolean;
}): UseDataWarehousesResult => {
  const { data, loading } = useDataWarehousesQuery({ skip: options?.skip });

  const warehouses: DataWarehouseRefFragment[] = useMemo(
    () =>
      (getTypeOrNull(data?.dataWarehouses)?.dataWarehouses ?? []).filter(
        warehouse => !warehouse.deleteTime,
      ),
    [data],
  );

  return {
    warehouses,
    primaryWarehouse: findPrimaryWarehouse(warehouses),
    isLoading: loading,
    error: getError(data?.dataWarehouses),
  };
};
